import '../css/main.scss';
import naja from 'naja';

// Global behaviour, bundled into every page. Page-specific scripts live in js/pages/ and
// are loaded on demand via {asset 'js/pages/…'} in the templates that need them.
import './modules/site.js';
import './modules/section-heights.js';
import './modules/smooth-scroll.js';
import './modules/dialog.js';
import '../../../portal/assets/js/modules/form-submit-guard.js';
import './modules/request-error-notice.js';
import './modules/tooltip.js';
import './modules/reviews.js';
import './modules/accordion.js';
import './modules/cookie-consent.js';
import '../../../portal/assets/js/modules/turnstile.js';

// Naja replaces the former jQuery nette.ajax — it declaratively handles forms/links with the
// `ajax` class and powers programmatic requests (e.g. modal snippet reset in dialog.js).
// Hard redirects by default: a forgotten opt-in would fail silently, a forgotten opt-out is visible.
document.addEventListener('DOMContentLoaded', () => {
  naja.initialize({ forceRedirect: true });
});

window.naja = naja;
